export function clearGridCache() {
  // Reset all grid states and new note inputs
  const lsKeys = Object.keys(localStorage)

  for (const key of lsKeys) {
    if (key.includes("TABLE") || key.includes("new-note"))
      localStorage.removeItem(key)
  }

  // After clearing grid keys from LS, both grid views (my/all) will try to set initial filter state from the URL. To avoid this, clear the URL search params immediately.
  const currentUrl = window.location.href
  const url = new URL(currentUrl)
  url.search = ""
  window.history.replaceState({}, document.title, url.toString()) // Update the URL without reloading
}
